import React from "react";
import "./gallery.css";

const Gallery = () => {
    const images = [];

    // Automatically add all 25 image paths
    for (let i = 1; i <= 49; i++) {
        images.push(`${process.env.PUBLIC_URL}/images/phto${i}.jpeg`);
    }

    return (
        <div className="gallery-container">
            <h2 className="gallery-title" >📸 गावाचा विकास – छायाचित्रांतून</h2>

            <div className="gallery-grid">
                {images.map((src, index) => (
                    <div className="gallery-card" key={index}>
                        <img
                            src={src}
                            alt={`Gallery Photo ${index + 1}`}
                            className="gallery-img"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Gallery;
